'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StringColumn = require('linksoft/data-tables/renderers/StringColumn');

var _EnumColumn2 = require('linksoft/data-tables/renderers/EnumColumn');

var _EnumColumn3 = _interopRequireDefault(_EnumColumn2);

var _odataUri = require('linksoft/utils/odata-uri');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlagEnumColumn = function (_EnumColumn) {
    _inherits(FlagEnumColumn, _EnumColumn);

    function FlagEnumColumn() {
        _classCallCheck(this, FlagEnumColumn);

        return _possibleConstructorReturn(this, (FlagEnumColumn.__proto__ || Object.getPrototypeOf(FlagEnumColumn)).apply(this, arguments));
    }

    _createClass(FlagEnumColumn, [{
        key: 'displayValue',
        value: function displayValue(value) {
            var enums = this.api.init().enums;
            var targetEnum = enums && this.options.dataType && enums[this.options.dataType];
            if (targetEnum) {
                return value.split(',').map(function (f) {
                    return f.trim();
                }).map(function (f) {
                    return targetEnum.find(function (e) {
                        return e.value === f;
                    });
                }).filter(function (x) {
                    return x;
                }).map(function (x) {
                    return x.text;
                }).join(', ');
            }
            return value;
        }
    }, {
        key: 'buildFilterExpression',
        value: function buildFilterExpression(fieldName, columnFilter) {
            return fieldName + ' has \'' + columnFilter + '\'';
        }
    }]);

    return FlagEnumColumn;
}(_EnumColumn3.default);

exports.default = FlagEnumColumn;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/datatables/FlagEnumColumn.js
// module id = 425
// module chunks = 0